import Enum from './enum'

class PersonStatus extends Enum
{
  constructor(value) {
    super(value);
  }
}

PersonStatus.init({
  RESIDENT: 'resident',
  NON_RESIDENT: 'non-resident'
}, {
  RESIDENT: 'person-status.resident',
  NON_RESIDENT: 'person-status.non-resident'
});

export default PersonStatus;
